import { render, staticRenderFns } from "./ModalKerja.vue?vue&type=template&id=77b8db99&scoped=true&"
import script from "./ModalKerja.vue?vue&type=script&lang=js&"
export * from "./ModalKerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8db99",
  null
  
)

export default component.exports